"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Image100 = function Image100() {
  return _react2.default.createElement(
    "svg",
    { width: "28", height: "28", viewBox: "0 0 28 28", version: "1.1" },
    _react2.default.createElement(
      "title",
      null,
      "100"
    ),
    _react2.default.createElement(
      "g",
      { className: "hundred" },
      _react2.default.createElement("circle", { className: "colored-circle", fill: "#254049", cx: "14", cy: "14", r: "1" }),
      _react2.default.createElement("circle", { className: "white-circle", fill: "#FFFFFF", cx: "14", cy: "14", r: "1" }),
      _react2.default.createElement(
        "g",
        { className: "hundred-number", transform: "translate(3.000000, 0.000000)" },
        _react2.default.createElement("path", { fill: "#254049", d: "M2.6 16.5C2.6 16.5 2.5 16.5 2.4 16.5 1.9 16.4 1.5 15.9 1.6 15.4L3.2 5.7 1.9 6.7C1.4 7.1 0.8 7 0.5 6.6 0.1 6.1 0.2 5.5 0.6 5.1L6 1 3.6 15.7C3.5 16.2 3.1 16.5 2.6 16.5M11 3.1C10.5 3.5 9.6 5.3 9.2 8L9.2 8C8.8 10.4 9.1 12.1 9.4 12.6 9.9 12.1 10.8 10.3 11.2 7.7 11.6 5.2 11.3 3.6 11 3.1L11 3.1ZM9.3 14.7C8.8 14.7 8.3 14.4 7.9 14 6.9 12.8 6.9 9.9 7.2 7.7 7.6 5.2 8.8 1 11.1 1 11.6 1 12.1 1.2 12.4 1.7 13.5 2.9 13.5 5.7 13.2 8 12.8 10.5 11.6 14.7 9.3 14.7L9.3 14.7ZM19 2.1C18.5 2.5 17.6 4.3 17.2 7L17.2 7C16.8 9.4 17.1 11.1 17.4 11.6 17.9 11.1 18.8 9.3 19.2 6.7 19.6 4.2 19.3 2.6 19 2.1L19 2.1ZM17.3 13.7C16.8 13.7 16.3 13.4 15.9 13 14.9 11.8 14.9 8.9 15.2 6.7 15.6 4.2 16.8 0 19.1 0 19.6 0 20.1 0.2 20.4 0.7 21.5 1.9 21.5 4.7 21.2 7 20.8 9.5 19.6 13.7 17.3 13.7L17.3 13.7Z" }),
        _react2.default.createElement("path", { fill: "#254049", className: "hundred-underline first", d: "M0.9 20.8L22.7 16 1.5 23C0.9 23.1 0.2 22.8 0.1 22.2 -0.1 21.7 0.2 21 0.8 20.8 0.8 20.8 0.8 20.8 0.9 20.8" }),
        _react2.default.createElement("path", { fill: "#254049", className: "hundred-underline second", d: "M3.5 25.8L21.4 20.1 4.3 27.9C3.7 28.2 3.1 27.9 2.8 27.4 2.6 26.8 2.8 26.1 3.4 25.9 3.4 25.9 3.5 25.8 3.5 25.8" }),
        _react2.default.createElement("path", { d: "M0 25L23 19 23 24 0 30 0 25Z", className: "mask bottom", fill: "#FFFFFF", opacity: "0" }),
        _react2.default.createElement("path", { d: "M0 19L23 13 23 18 0 24 0 19Z", className: "mask top", fill: "#FFFFFF", opacity: "0" })
      )
    )
  );
}; /* eslint-disable max-len */
exports.default = Image100;